import { createMuiTheme } from '@material-ui/core/styles';
import {
  headerStylings,
  statCardStyling,
  gridStyling,
  metricTileStyling,
  topMenuTypography,
} from './tokens';

const dashboardTheme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  header: {
    ...headerStylings,
  },
  grid: {
    ...gridStyling,
  },
  statCard: {
    ...statCardStyling,
  },
  metricTile: {
    ...metricTileStyling,
  },
  topMenu: {
    ...topMenuTypography,
  },
});

export default dashboardTheme;
